module.exports = "<div class=\"sk-three-bounce\">\n  <div class=\"sk-child sk-bounce1\"></div>\n  <div class=\"sk-child sk-bounce2\"></div>\n  <div class=\"sk-child sk-bounce3\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/loader/loader.component.html
// module id = ./src/app/shared/components/loader/loader.component.html
// module chunks = main